import {
  Modal,
  Button as AntButton,
  Checkbox,
  Radio,
  Switch,
  TimePicker,
} from 'antd';
import { Field, Form, Formik } from 'formik';
import { Fragment } from 'react';
import { object } from 'yup';
import { Button, DatePicker, DateTimePicker, Text } from '.';
import { SingleSelect } from './SingleSelect';
import { PatternFormat } from 'react-number-format';
import TextArea from 'antd/es/input/TextArea';
import { classNames } from 'src/utilities';
import { TreeSelectDropdown } from './TreeSelect';
import { Bars } from 'react-loader-spinner';
import { AppointmentType } from './AppointmentType';
import { isEmpty } from 'lodash-es';

const vSchema = object({});
export const ModalComponent = ({
  open,
  sections, // Array of sections with headings and fields
  validationSchema = vSchema,
  initialValues,
  className,
  submitButtonText = 'Ok',
  cancelButtonText = 'Cancel',
  handleCancel = () => null,
  handleSubmit,
  customBody,
  additionalBody,
  loading,
  centered,
  closable,
  handleRadioButton,
  followUpFlag,
  appointmentTypes,
  setShowExistingFlag,
  radioButtonValue,
  sendNow,
  submitLoading,
  setConditionByType,
  width = 900,
}) => {
  const allAppointmentTypes = !isEmpty(appointmentTypes)
    ? [...appointmentTypes]
    : [];

  return (
    <Formik
      initialValues={{
        ...initialValues,
        radioButton: radioButtonValue,
      }}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={handleSubmit}
    >
      {({ errors, touched, resetForm, setFieldValue, values }) => (
        <Modal
          open={open}
          onCancel={handleCancel}
          afterClose={() => resetForm()}
          className={classNames(`custom-modal`, className ? className : '')}
          centered={centered}
          footer={null}
          maskClosable={false}
          closable={closable}
          width={width}
        >
          <div className="modal_background">
            <Form
              autoComplete="off"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                }
              }}
            >
              {sections?.map((section, index) => (
                <div className="modal__header" key={`section-${index}`}>
                  <div className="modal__header mb-3">
                    {section.heading === 'radio_group' ? (
                      <>
                        <div className="">Add appointments</div>
                        {followUpFlag && (
                          <div className="flex items-center mt-2">
                            <span className="font-change">
                              Appointment type
                            </span>
                            <span className="ml-3">
                              <Radio.Group
                                onChange={(e) => {
                                  setFieldValue('condition_id', null);
                                  setFieldValue('first_name', '');
                                  setFieldValue('last_name', '');
                                  setFieldValue('preferred_name', '');
                                  setFieldValue('phone_text', null);
                                  setFieldValue('email_text', '');
                                  setFieldValue('birth_date', null);
                                  setFieldValue('search_patient_name', null);
                                  setShowExistingFlag(false);
                                  setFieldValue('radioButton', e.target.value);
                                  setConditionByType([]);
                                  handleRadioButton(e);
                                }}
                                value={values.radioButton}
                              >
                                {appointmentTypes.map((item) => (
                                  <AppointmentType
                                    key={item.value}
                                    item={item}
                                    appointmentTypes={allAppointmentTypes}
                                  />
                                ))}
                              </Radio.Group>
                            </span>
                          </div>
                        )}
                      </>
                    ) : (
                      section.heading
                    )}
                  </div>
                  <div className="modal____body">
                    {customBody ? (
                      customBody
                    ) : (
                      <div className={section.className}>
                        {section.fields.map(
                          (
                            {
                              type,
                              name,
                              title,
                              helperTitle,
                              options,
                              placeholder,
                              onChange,
                              onKeyDown,
                              onBlur,
                              disabled,
                              disableDate,
                              disableTime,
                              className,
                              dropdownArrow,
                              disabledDate,
                              placement,
                              extraIcon,
                              defaultValue,
                              onSearch,
                              loading,
                              notFoundContent,
                              getPopupContainer,

                              ...props
                            },
                            fieldIndex
                          ) => (
                            <Fragment key={`${name}-${fieldIndex}`}>
                              <div
                                className={`${className} modal__form-el`}
                                key={name}
                              >
                                <Text
                                  type="p"
                                  className={`modal__form-el-label mb-2 ${
                                    touched[name] && errors[name] ? 'error' : ''
                                  }`}
                                >
                                  {title}
                                </Text>

                                {type === 'datepicker' ? (
                                  <DatePicker
                                    name={name}
                                    disabledDate={disabledDate}
                                    placement={placement}
                                    className={className}
                                    placeholder={placeholder}
                                    value={values[name] || defaultValue}
                                  />
                                ) : type === 'switch' ? (
                                  <Text
                                    type="label"
                                    className="modal__form-el-label mb-2"
                                  >
                                    {helperTitle}
                                    <Switch
                                      className="mx-3"
                                      key={name}
                                      checked={sendNow}
                                      style={{ backgroundColor: '#00000040' }}
                                      onChange={
                                        onChange
                                          ? (value, option) => {
                                              onChange(
                                                value,
                                                option,
                                                setFieldValue
                                              );
                                            }
                                          : () => null
                                      }
                                    />
                                  </Text>
                                ) : type === 'datetimepicker' ? (
                                  <DateTimePicker
                                    name={name}
                                    disableDate={disableDate}
                                    disableTime={disableTime}
                                    format="MM-DD-YYYY h:mm a"
                                  />
                                ) : type === 'select' ? (
                                  <SingleSelect
                                    name={name}
                                    options={options}
                                    placeholder={placeholder}
                                    disabled={disabled}
                                    className={`single-select ${
                                      disabled
                                        ? 'text-gray-700 cursor-not-allowed opacity-50'
                                        : ''
                                    } ${
                                      touched[name] && errors[name]
                                        ? 'error'
                                        : ''
                                    }`}
                                    popupClassName={props?.popupClassName}
                                    onChange={
                                      onChange
                                        ? (value, option) => {
                                            onChange(
                                              value,
                                              option,
                                              setFieldValue
                                            );
                                          }
                                        : () => null
                                    }
                                    value={values[name]}
                                    dropdownArrow={dropdownArrow}
                                    error={touched[name] && errors[name]}
                                    extraIcon={extraIcon}
                                    onSearch={onSearch}
                                    loading={loading}
                                    notFoundContent={notFoundContent}
                                    getPopupContainer={getPopupContainer}
                                  />
                                ) : type === 'treeSelect' ? (
                                  <TreeSelectDropdown
                                    showSearch={true}
                                    name={name}
                                    options={options}
                                    placeholder={placeholder}
                                    disabled={disabled}
                                    className={`single-select ${
                                      touched[name] && errors[name]
                                        ? 'error'
                                        : ''
                                    }`}
                                    popupClassName={props?.popupClassName}
                                    onChange={onChange}
                                    value={values[name]}
                                  />
                                ) : type === 'label' ? (
                                  <div className="modal__form-el">
                                    <Text className={``}>{title}</Text>
                                  </div>
                                ) : type === 'TimePicker' ? (
                                  <div>
                                    <TimePicker
                                      name={name}
                                      use12Hours
                                      format="h:mm A"
                                      className="w-full h-12"
                                      defaultValue={defaultValue}
                                      onChange={(values, time) => {
                                        onChange(values, time, setFieldValue);
                                      }}
                                    />
                                  </div>
                                ) : type === 'radio' ? (
                                  <div>
                                    {options.map((option) => (
                                      <label
                                        key={option.value}
                                        className="modal__form-el-radio custom-radio input"
                                      >
                                        <input
                                          type="radio"
                                          name={name}
                                          value={option.value}
                                          onChange={onChange}
                                          // defaultChecked={option.value}
                                          // defaultValue={option.value}
                                        />
                                        {option.label}
                                      </label>
                                    ))}
                                  </div>
                                ) : type === 'phonenumber_text' ? (
                                  <PatternFormat
                                    className={`modal__form-el-field ${
                                      touched[name] && errors[name]
                                        ? 'error'
                                        : ''
                                    } ${
                                      disabled
                                        ? 'text-gray-700 cursor-not-allowed opacity-50'
                                        : ''
                                    }`}
                                    key={name}
                                    type={type}
                                    name={name}
                                    disabled={disabled}
                                    placeholder={placeholder}
                                    {...props}
                                    format="(###) ###-####"
                                    allowEmptyFormatting={false}
                                    value={values[name] || ''}
                                    autoComplete="off"
                                    role="presentation"
                                    onValueChange={(values) => {
                                      if (onChange) {
                                        onChange(values.value, setFieldValue);
                                        setFieldValue(name, values.value);
                                      } else {
                                        setFieldValue(name, values.value);
                                      }
                                    }}
                                  />
                                ) : type === 'dobText' ? (
                                  <PatternFormat
                                    className={`modal__form-el-field ${
                                      touched[name] && errors[name]
                                        ? 'error'
                                        : ''
                                    } ${
                                      disabled
                                        ? 'text-gray-700 cursor-not-allowed opacity-50'
                                        : ''
                                    }`}
                                    key={name}
                                    type={type}
                                    name={name}
                                    disabled={disabled}
                                    placeholder={placeholder}
                                    {...props}
                                    format="##-##-####"
                                    allowEmptyFormatting={false}
                                    value={values[name] || ''}
                                    onValueChange={(values) => {
                                      if (onChange) {
                                        onChange(values.value, setFieldValue);
                                        setFieldValue(name, values.value);
                                      } else {
                                        setFieldValue(name, values.value);
                                      }
                                    }}
                                    autoComplete="off"
                                    role="presentation"
                                  />
                                ) : type === 'checkBox' ? (
                                  <div
                                    className={`${className} modal__form-el`}
                                    key={name}
                                  >
                                    <Text
                                      type="label"
                                      className="modal__form-el-label mb-2"
                                    >
                                      <Checkbox
                                        className="mr-3"
                                        key={name}
                                        type={type}
                                        disabled={disabled}
                                        name={name}
                                        onChange={(e) => {
                                          e.target.checked
                                            ? setFieldValue(name, true)
                                            : setFieldValue(name, false);
                                        }}
                                        checked={values[name]}
                                      />
                                      {helperTitle}
                                    </Text>
                                    {touched[name] && errors[name] && (
                                      <Text
                                        type={'error'}
                                        className={'error mt-2'}
                                      >
                                        {errors[name]}
                                      </Text>
                                    )}
                                  </div>
                                ) : type === 'textarea' ? (
                                  <TextArea
                                    className="modal__form-el-field-textarea"
                                    name={name}
                                    placeholder={placeholder}
                                    value={values[name]}
                                    onChange={(e) =>
                                      setFieldValue(name, e.target.value)
                                    }
                                    style={{ resize: 'none' }}
                                  />
                                ) : type === 'text' ? (
                                  <Field
                                    className={`modal__form-el-field ${
                                      touched[name] && errors[name]
                                        ? 'error'
                                        : ''
                                    } ${
                                      disabled
                                        ? 'text-gray-700 cursor-not-allowed opacity-50'
                                        : ''
                                    }`}
                                    key={name}
                                    name={name}
                                    disabled={disabled}
                                    placeholder={placeholder}
                                    value={values[name]}
                                    role="presentation"
                                    autoComplete="off"
                                    onBlur={onBlur}
                                    onKeyDown={onKeyDown}
                                    onChange={(e) => {
                                      if (onChange) {
                                        onChange(e, setFieldValue);
                                        setFieldValue(name, e.target.value);
                                      } else {
                                        setFieldValue(name, e.target.value);
                                      }
                                    }}
                                  />
                                ) : type === 'providerEmails' ? (
                                  <Field
                                    className={`modal__form-el-field ${
                                      touched[name] && errors[name]
                                        ? 'error'
                                        : ''
                                    }`}
                                    key={name}
                                    name={name}
                                    disabled={disabled}
                                    placeholder={placeholder}
                                    value={values[name] || null}
                                    role="presentation"
                                    autoComplete="off"
                                    onChange={onChange}
                                    onKeyDown={onKeyDown}
                                  />
                                ) : type === 'radio_button' ? (
                                  <Radio.Group name={name}></Radio.Group>
                                ) : (
                                  <Field
                                    className={`modal__form-el-field ${
                                      touched[name] && errors[name]
                                        ? 'error'
                                        : ''
                                    }`}
                                    key={name}
                                    type={type}
                                    name={name}
                                    disabled={disabled}
                                    placeholder={placeholder}
                                    {...props}
                                    value={values[name] || null}
                                    role="presentation"
                                    autoComplete="off"
                                  />
                                )}

                                {touched[name] && errors[name] && (
                                  <Text type={'error'} className={'error'}>
                                    {errors[name]}
                                  </Text>
                                )}
                              </div>
                            </Fragment>
                          )
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ))}
              {additionalBody ? additionalBody : ''}
              <div className="modal__form-footer">
                {cancelButtonText && (
                  <div className="button-container">
                    <Button
                      type="button"
                      loading={loading}
                      className="cancel-button"
                      onClick={() => handleCancel()}
                    >
                      {cancelButtonText}
                    </Button>
                  </div>
                )}
                {submitButtonText && (
                  <div className="button-container">
                    <AntButton
                      htmlType="submit"
                      loading={loading}
                      className="ih-button-primary"
                      disabled={submitLoading}
                    >
                      {!submitLoading ? (
                        submitButtonText
                      ) : (
                        <Bars
                          height="25"
                          width="25"
                          color="#ffffff"
                          ariaLabel="bars-loading"
                          wrapperStyle={{}}
                          wrapperClass=" justify-center"
                          visible={true}
                        />
                      )}
                    </AntButton>
                  </div>
                )}
              </div>
            </Form>
          </div>
        </Modal>
      )}
    </Formik>
  );
};
